import { Badge } from "@/components/ui/badge";
import type { LeadImportJob } from "./types";

interface ImportJobsListProps {
  importJobs: LeadImportJob[] | null;
}

export const ImportJobsList = ({ importJobs }: ImportJobsListProps) => {
  if (!importJobs || importJobs.length === 0) return null;

  return (
    <div className="bg-muted p-4 rounded-md mb-4">
      <h3 className="font-medium mb-2">Recent Imports</h3>
      <div className="space-y-2">
        {importJobs.map((job) => (
          <div key={job.id} className="flex justify-between items-center text-sm">
            <span>{job.file_path}</span>
            <Badge variant={job.status === 'completed' ? 'default' : 'secondary'}>
              {job.status}
            </Badge>
          </div>
        ))}
      </div>
    </div>
  );
};